import script from "./CreateHeadHunter.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateHeadHunter.vue?vue&type=script&setup=true&lang=js"

import "./CreateHeadHunter.vue?vue&type=style&index=0&id=4adbc1e7&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4adbc1e7"]])

export default __exports__